import { createGlobalStyle } from 'styled-components'
import { rem } from 'polished'

export { MapboxGlobalStyles } from 'components/Common/Mapbox/MapboxGlobalStyles'

export const TripPlannerMapControlStyles = createGlobalStyle`
  .trip-planner-map-controls .mapboxgl-ctrl-group {
    border-start-start-radius: ${rem(8)};
    border-start-end-radius: ${rem(8)};
    border-end-start-radius: ${rem(8)};
    border-end-end-radius: ${rem(8)};
    box-shadow: 0 0 0 2px #0000001a, 0 ${rem(2)} ${rem(8)} rgba(0, 0, 0, 0.15);
  }

  .trip-planner-map-controls .mapboxgl-ctrl-group button:first-child {
    border-start-start-radius: ${rem(8)};
    border-start-end-radius: ${rem(8)};
    border-end-end-radius: 0;
    border-end-start-radius: 0;
  }

  .trip-planner-map-controls .mapboxgl-ctrl-group button:last-child {
    border-start-start-radius: 0;
    border-start-end-radius: 0;
    border-end-end-radius: ${rem(8)};
    border-end-start-radius: ${rem(8)};
  }

  .trip-planner-map-controls .mapboxgl-ctrl-group button:only-child {
    border-start-start-radius: ${rem(8)};
    border-start-end-radius: ${rem(8)};
    border-end-start-radius: ${rem(8)};
    border-end-end-radius: ${rem(8)};
  }
`
